import { useEffect } from 'react'
import { useIngredientsStore } from '../stores/ingredientsStore'

export const useIngredients = () => {
  const {
    ingredients,
    currentIngredient,
    isLoading,
    error,
    filters,
    fetchIngredients,
    fetchIngredient,
    createIngredient,
    updateIngredient,
    deleteIngredient,
    setFilters,
    resetFilters,
    invalidateCache,
  } = useIngredientsStore()

  useEffect(() => {
    // Fetch ingredients if they're not loaded
    if (!ingredients && !isLoading) {
      fetchIngredients()
    }
  }, [ingredients, isLoading, fetchIngredients])

  const refetch = () => {
    fetchIngredients()
  }

  return {
    ingredients,
    currentIngredient,
    isLoading,
    error,
    filters,
    fetchIngredients,
    fetchIngredient,
    createIngredient,
    updateIngredient,
    deleteIngredient,
    setFilters,
    resetFilters,
    refetch,
    invalidateCache,
  }
}